<template>
    <div class="col-md-6">
        <label class="attribute-label m-bottom-12" :for="id">{{ extraChargeAttribute.attribute_name }}</label>

        <div class="input-group width-100">
            <input type="number" step="0.01" :name="name" class="form-control price-new-inputs" :id="id" v-model="numberValue">
            <span class="input-group-addon input-group-addon-new-design" style="background-color: #F5F5F6 !important;">
                <b> {{ currency.currency_symbol }} </b>
            </span>
        </div>
        <b v-if="numberValue != suggested && suggested !=0" class="text-style-n">Recommended: {{ suggested }}</b>
    </div>
</template>

<script>
export default {
    name: "ExtraChargeAttribute",
    props: {
        currency: {
            type: Object,
            required: true
        },
        extraChargeAttribute: {
            type: Object,
            required: true
        },
        suggestedPrice: {
            type: Number,
            required: true
        },
        value: null,
        service: null
    },
    data() {
        return {
            numberValue: this.value
        }
    },
    computed: {
        suggested() {
            return this.suggestedPrice;
        },
        /**
         * get extraChargeAttribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.service.clone)) {
                return `attribute_${this.service.service_id}${this.extraChargeAttribute.attribute_id}_${this.service.clone}`;
            }
            if (typeof this.extraChargeAttribute != "undefined"   ){
                return `attribute_${this.service.service_id}${this.extraChargeAttribute.attribute_id}`;
            }

        },
        /**
         * get extraChargeAttribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.service.clone)) {
                return `attribute_${this.service.service_id}${this.extraChargeAttribute.attribute_id}_${this.service.clone}`;
            }
            if (typeof this.extraChargeAttribute != "undefined" ){
            return `attribute_${this.service.service_id}${this.extraChargeAttribute.attribute_id}`;
            }
        }
    },
    watch: {
        value(value){
            this.numberValue = value
        },
        numberValue(value) {
            this.$emit('input', +value)
        }
    },
    methods :{
        setValueToSuggested() {
            this.numberValue = this.suggested

            if ( typeof this.extraChargeAttribute != "undefined" && this.extraChargeAttribute.service_attribute_value){
                this.numberValue = this.extraChargeAttribute.service_attribute_value;
            }
        }
    },
    mounted() {

        this.$nextTick(() => {
            this.setValueToSuggested()
        })
    }
}
</script>

<style scoped>

</style>